module.exports = __webpack_public_path__ + "static/Editor-Toolbar-a5829949ebb01ccf72d2a949712f40f3.png";